import React, {
  memo,
  ForwardedRef,
  useImperativeHandle,
  useRef,
} from 'react';
import Chart from '..';
import { LineChartProps, ChartRef } from '../_config/interface';
import { makeupOptions } from '../_config/utils';
import RadarPoint from './RadarPoint';

const LineChartInner: React.ForwardRefRenderFunction<ChartRef, LineChartProps> = (props, ref: ForwardedRef<ChartRef>) => {
  const {
    className = '',
    style = {},
    height,
    nowTime,
    preTime,
    isMultipleCompetitor,
    hasDataZoom,
    chartEventConfig,
    notMerge,
    ripples
  } = props;
  const chartRef = useRef<ChartRef>(null);
  let option = makeupOptions(props, 'line');
  if (ripples) {
    option = {
      ...option,
      animation: false
    };
  }

  // 刷新图表
  const refreshChart = () => {
    instance()?.setOption(option);
  };

  // 获取实例
  const instance = () => {
    return chartRef?.current?.instance();
  };

  // 对父组件暴露的方法
  useImperativeHandle(ref, () => ({
    instance,
    refreshChart
  }));

  const chartStyle = {
    ...(height ? { height: `${height}px` } : {}),
    width: '100%',
    position: 'relative',
    ...style,
  };

  return (
    <div className={`chart-box ${className}`} style={chartStyle}>
      <Chart
        ref={chartRef}
        option={option}
        hasDataZoom={hasDataZoom}
        chartEventConfig={chartEventConfig}
        notMerge={notMerge}
      />
      {isMultipleCompetitor && (
        <div
          style={{
            position: 'absolute',
            bottom: '0px',
            left: '3%',
            opacity: 0.45,
          }}
        >
          <p style={{ marginBottom: '8px', fontSize: '12px' }}>{nowTime}</p>
          <p style={{ fontSize: '12px' }}>{preTime}</p>
        </div>
      )}
      {ripples && <RadarPoint chartRef={chartRef} option={option} />}
    </div>
  );
};

const LineChart = memo(React.forwardRef(LineChartInner));

export default LineChart;
